import React, { useState, useEffect } from "react";
import axios from "axios";
import { Carousel, Table, Input, DatePicker, Modal, Card, Row, Col, message, Image, Checkbox, Button } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { DownloadOutlined, PlusOutlined, EditOutlined, CloseCircleOutlined, DownCircleOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;
const { Meta } = Card;
const AdminCourseStudentAttendanceOverview = () => {
    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 100,
        },
        {
            title: '2/10',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            align: 'center',
            width: 100,
        },
        {
            title: '2/11',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            align: 'center',
            width: 100,
        },
        {
            title: '2/13',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            align: 'center',
            width: 100,
        },
        {
            title: '2/14',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            align: 'center',
            width: 100,
        },
        {
            title: '2/15',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            align: 'center',
            width: 100,
        },
        {
            title: '2/16',
            key: 'address',
            render: (text, record, index) => (
                <>
                    {record.address == '出席' ?
                        <>
                            <Row justify={'center'}>
                                <Col style={{ backgroundColor: '#81EDC2', width: '50px' }}>{record.address}</Col>
                            </Row>
                        </> : null
                    }
                </>),
            width: 100,
            align: 'center',
        },
        {
            title: '出席堂數',
            dataIndex: 'age',
            key: '8',
            fixed: 'right',
            width: 100,
            align: 'center',
        },
        {
            title: '產生繳費單',
            key: 'operation',
            fixed: 'right',
            width: 130,
            align: 'center',
            render: () => <Button type='default' style={{ color: 'red' }} shape="round">產生繳費單</Button>,
        },
    ];
    const data = [];
    for (let i = 0; i < 100; i++) {
        data.push({
            key: i,
            name: `王小明`,
            age: 6,
            address: `出席`,
        });
    }

    return (
        <>
            <Row gutter={[8, 8]} justify={'end'}>
                <Col>
                    <Button type='primary' icon={<DownloadOutlined />}>下載出席狀況</Button>
                </Col>
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        scroll={{
                            // x: 1500,
                            y: 450,
                        }}
                    />
                </Col>
            </Row >

        </>
    )
}
export default AdminCourseStudentAttendanceOverview;